(function () {
    'use strict';

    angular.module('invesfleet')


    .component('elim', {
  		templateUrl: 'app/views/componentTemplates/elimTemplate.html',
  		bindings: {
    		num: '=',
    		text: '@',
    		ngClick: '&'
  		}
	})

	
	.component('otro', {
  		templateUrl: 'app/views/componentTemplates/elimTemplate.html',
  		bindings: {
    		num: '=',
    		text: '@',
    		ngClick: '&'
  		}
	});

})();